<app-table
  [data]="data"
  [columns]="headers"
  [mainField]="'name'"
  [title]="'configuration.discounts.listTitle' | transloco"
  [rows]="limit"
  [totalRecords]="totalRecords"
  [loadError]="loadError"
  (retryLoad)="loadDiscounts()"
  [isLoading]="isLoading"
  (onPageChange)="onPageChange($event)"
  (onSort)="onSort($event)"
  [showActionButton]="!isMobile"
  [actionButtonLabel]="isMobile ? '' : ('configuration.discounts.createButton' | transloco)"
  [crudComponent]="crudDiscount"
  (actionButtonClick)="crudDiscount.show()"
  [getMenuActions]="getMenuActions.bind(this)"
  (menuActionTriggered)="menuActionTriggered($event)"
  (rowSelected)="onRowSelected($event)"
></app-table>

@if (isMobile) {
  <app-button
    class="floating-add-button"
    icon="Plus"
    (click)="crudDiscount.show()"
  ></app-button>
}

<app-discount-crud #crudDiscount (discountUpdated)="loadDiscounts()"></app-discount-crud>
